module.exports = {
  START: 'Start',
  AUTH_CODE: 'Authorization Code',
  REFRESH_TOKEN: 'Refresh Token'
};
